import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ID } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IProductStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IProductStatsResponse>,
  IPathBaseParam,
  { warehouse_id?: ID }
>("stores.products.stats");

export const stats = {
  ...getApis,
};
